import React from "react"
import { AppBulkEditAction } from "@components"

import { useUserSettingsAcriss, useUserSettingsAcrissValidator } from "../../../@hooks"


export default function UserSettingAcrissDrawerSubmit() {
	const { isLoading, handleSubmitAcrissFormData } = useUserSettingsAcriss()
	const { isValid } = useUserSettingsAcrissValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitAcrissFormData}
	>
		Save
	</AppBulkEditAction>
}